import type {HeroBlockProps} from "./types";

import {Heading} from "@digdir/designsystemet-react";
import {ArrowRightIcon} from "@navikt/aksel-icons";
import Link from "@/components/link";
import clsx from "clsx";

export type {HeroBlockProps};

export const HeroBlock = ({heading, imageUrl, imageRights, linkUrl, linkText, primary}: HeroBlockProps) => {
    return (
        <div
            className="content flex flex-col items-start gap-[17px] pt-[17px] pb-9 px-4 bg-white md:gap-5 md:pt-5 md:pb-10 xl:gap-8 xl:pt-5.5 lg:pb-12">
            <div
                className={clsx("w-full flex flex-col justify-between items-center gap-[17px] sm:flex-row md:gap-6 xl:gap-8",
                    !primary && "pt-[17px] border-t border-neutralNsf-subtle md:pt-5 xl:pt-5")
                }
            >
                {imageUrl && (
                    <div className={clsx("order-1 w-full sm:w-[236px] lg:w-[288px] xl:w-[348px] 2xl:w-[406px] aspect-auto sm:aspect-square", primary && "sm:order-2")}>
                        <img
                            src={imageUrl ? `${imageUrl}?width=406` : ''}
                            alt={imageRights}
                            className=" h-full object-cover aspect-square" fetchPriority="high"
                        />
                    </div>
                )}

                <div className="flex flex-col order-2 w-full sm:basis-full sm:order-1 md:basis-7/12">
                    <Heading className={clsx(primary ? "text-red heading-xl" : "text-brand-accent heading-lg")}>
                        {heading}
                    </Heading>
                    {linkUrl && (
                        <Link href={linkUrl} className="w-fit">
                            <span>{linkText}</span>
                            <ArrowRightIcon/>
                        </Link>
                    )}
                </div>
            </div>
        </div>
    );
};
